import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_71j1sxhj: FaireBrandEntity = {
  token: "b_71j1sxhj",
  type: "brand",
  name: "IMPAPER",
  avatarUrl:
    "https://cdn.faire.com/fastly/a76434a200ba43ae120a96d03951257de1f81921643212649d0b312eb87a8ebf.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9b9f05efc21516f4a4ac5912f588c66a004b03aa071e28eab622df9f1d58ea4e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a76434a200ba43ae120a96d03951257de1f81921643212649d0b312eb87a8ebf.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9b9f05efc21516f4a4ac5912f588c66a004b03aa071e28eab622df9f1d58ea4e.jpeg",
  location: "Calgary, AB, CAN",
  minimumOrderDollars: 99,
  rating: 5,
  reviewCount: 53,
  isInsider: false,
  description:
    "IMPAPER (Impact Paper) is a paper goods brand where for every product purchased, we make a contribution to a specific cause to help improve the lives of others. These causes range from giving meals, planting trees, giving vaccinations for diseases and more. We give through local and international non-profit organizations such as UNICEF, Trees For The Future, Feeding America, the Global Familymed Foundation and more. Furthermore, we have a commitment to the environment and strive to minimize our carbon footprint. We aim to bring forth a line of products that reach out to our customers whether it is through inspiration or amusement and hope that we can empower our customers to create a better future for those in need. \n\nChristine Phan started IMPAPER in 2015 out of her love for paper goods and passion for design, sustainability and giving back. She has won numerous awards for her work with IMPAPER which include being recognized with the Alberta Council for Global Cooperation's Top 30 Under 30 Award and the Gift + Stationery 40 Under 40 Award.\n\nWe ship to the United States (USPS) and Canada (Canada Post) using local carriers so there are no additional cross-border charges and is duty-free.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:58.542Z",
    importedBy: "entity-db-cli",
  },
};
